module.exports = __webpack_public_path__ + "img/NoPath1@2x.4713e037.png";